<script>
import ListingResource from '../resources/listing'
import RoleResource from '../resources/role'
import LookingForResource from '../resources/lookingfor'
import ResourceSearch from '../components/ResourceSearch.vue'
import RegionSelect from '../components/RegionSelect.vue'
import NoResults from '../components/NoResults.vue'
import CompanyImage from '../components/CompanyImage.vue'
import JobPostingCell from '../components/JobPostingCell.vue'
import { mapGetters } from '../store'
import SkillResource from '../resources/skill'
import MetroAreaResource from '../resources/metroarea'

export default {
    name: 'Home',
    components: {
        ResourceSearch,
        RegionSelect,
        NoResults,
        CompanyImage,
        JobPostingCell
    },
    computed: {
        ...mapGetters(['userResource']),
        filterLength() {
            return Object.values(this.selectedFilterResources).reduce((value, curValue) => {
                let a = Array.isArray(value) ? value.length : value
                let b = Array.isArray(curValue) ? curValue.length : 1
                return a + b
            })
        },
        hasUserProfile() {
            if(this.userResource && this.userResource.readonly.profiles.length > 0) {
                return true
            }

            return false
        },
        classesHeaderSection() {
            let classes = ['header', 'page-title-blue']
            
            if(this.hasUserProfile) {
                classes.push('has-profile')
            }

            return classes
        }
    },
    watch: {
        pageData() {
            window.scroll(0, 0)
        },
        '$route': function() {
            this.search()
        },
        findWhatJobsText(text) {
            // This is a bugfix for when chrome worker goes to sleep (also happens sometimes when hot reloading)
            if(text.match(/undefined/gi)) {
                console.log('Received undefined in jobs...')
                clearTimeout(this.setTypingWhatJobsTimeout)
                // this.findWhatJobsText = this.findWhatJobsOptions[0].text
                // this.findWhatJobsLinkTo = this.findWhatJobsOptions[0].to
            }
        }
    },
    data() {
        return {
            loading: true,
            pageData: null,
            pageNumberCurrent: 1,
            listingResources: [],
            lookingForResources: [],
            filtersExpanded: false,
            findWhatJobsText: '',
            findWhatJobsLinkTo: {},
            setTypingWhatJobsTimeout: null,
            findWhatJobsOptions: [{
                text: 'Node.js',
                to: { name: 'alsoHome', params: { seoSlug: 'node-js-jobs' }, hash: '#' + JSON.stringify({ search: 'Node' }) }
            }, {
                text: 'Remote',
                to: { name: 'alsoHome', params: { seoSlug: 'remote-jobs' }, hash: '#' + JSON.stringify({ remote_level__gte: 3 }) }
            }, {
                text: 'Vue.js',
                to: { name: 'alsoHome', params: { seoSlug: 'vue-js-jobs' }, hash: '#' + JSON.stringify({ search: 'Vue' }) }
            }, {
                text: 'JavaScript',
                to: { name: 'alsoHome', params: { seoSlug: 'javascript-jobs' }, hash: '#' + JSON.stringify({ search: 'JavaScript' }) }
            }, {
                text: 'TypeScript',
                to: { name: 'alsoHome', params: { seoSlug: 'typescript-jobs' }, hash: '#' + JSON.stringify({ search: 'TypeScript' }) }
            }],
            searchKeywords: '',
            selectedFilterResources: {
                skills: [],
                regions: [],
                roles: [],
                remote_level: undefined,
                type: undefined,
            },
            filtersPersist: {},
            filtersReadFromQuery: false
        }
    },
    methods: {
        async onSubmit() {
            this.loading = true
            this.filtersExpanded = false
            this.setHashFilters(this.makeFilters())
            await this.search()
            this.loading = false
        },
        async onPageChange(num, force = false) {
            if (force || Number(num) !== Number(this.pageCurrent)) {
                this.loading = true
                this.listingResources = []
                this.pageData = await this.pageData.goToPage(num)
                this.listingResources = this.pageData.resources
                await this.resolveRelated()
                this.pageNumberCurrent = num
                this.setHashFilters(this.makeFilters())
                this.loading = false
            }
        },
        async search() {
            this.loading = true
            await this.readQueryFilters()
            let params = Object.assign({}, this.makeFilters(), this.filtersPersist)
            this.pageData = await ListingResource.active({ params, resolveRelated: true })
            this.listingResources = this.pageData.resources
            await this.resolveRelated()
            this.loading = false
        },
        resolveRelated() {
            let resolveAttributes = ['company.name', 'company.image.source', 'regions.name', 'skills.name', 'type.name']
            return Promise.all(this.listingResources.map((resource) => {
                return Promise.all(resolveAttributes.map((attr) => resource.resolveAttribute(attr)))
            }))
        },
        getHashFilters() {
            try {
                return JSON.parse(decodeURIComponent(location.hash.replace('#', '')))
            } catch(e) {
                return {}
            }
        },
        setHashFilters(filtersObj) {
            location.hash = JSON.stringify(filtersObj)
        },
        async readQueryFilters() {
            const filters = this.getHashFilters()
            
            if(!this.filtersReadFromQuery && Object.keys(filters).length) {
                if(filters.skills__in) {
                    let skillIds = filters.skills__in.split(',')
                    this.selectedFilterResources.skills = await Promise.all(skillIds.map((skillId) => SkillResource.detail(skillId)))
                }

                if(filters.regions__in) {
                    let regionIds = filters.regions__in.split(',')
                    this.selectedFilterResources.regions = await Promise.all(regionIds.map((regionId) => MetroAreaResource.detail(regionId)))
                }

                if(filters.roles__in) {
                    let roleIds = filters.roles__in.split(',')
                    this.selectedFilterResources.regions = await Promise.all(roleIds.map((roleId) => RoleResource.detail(roleId)))
                }

                if(filters.type__in) {
                    this.selectedFilterResources.type = await LookingForResource.detail(filters.type__in)
                }

                if(filters.years_experience) {
                    this.filtersYearsExperienceRequired = filters.years_experience
                }

                if(filters.remote_level__gte) {
                    this.selectedFilterResources.remote_level = filters.remote_level__gte
                }

                if(filters.search) {
                    this.searchKeywords = filters.search
                }

                if(filters.page) {
                    this.pageNumberCurrent = filters.page
                }

                this.filtersReadFromQuery = true
            }
        },
        makeFilters() {
            let extractIds = (resourceList) => resourceList.map((resource) => resource.id).join(',')

            let filters = {
                search: this.searchKeywords,
                skills__in: extractIds(this.selectedFilterResources.skills),
                regions__in: extractIds(this.selectedFilterResources.regions),
                type__in:  (this.selectedFilterResources.type) ? this.selectedFilterResources.type.id : undefined,
                role__in: extractIds(this.selectedFilterResources.roles),
                years_experience__gte: this.filtersYearsExperienceRequired,
                remote_level__gte: this.selectedFilterResources.remote_level,
                page: this.pageNumberCurrent
            }

            for(let key in filters) {
                if('undefined' === typeof filters[key] || !String(filters[key]).length) {
                    delete filters[key]
                }
            }

            return filters
        },
        async setTypingWhatJobsText(text, to, adding) {
            if(this.findWhatJobsText === text) {
                return true
            }

            if(adding || this.findWhatJobsText.length === 0) {
                this.findWhatJobsLinkTo = to
                await setTimeout(async () => {
                    if(text[this.findWhatJobsText.length]) {
                        this.findWhatJobsText = this.findWhatJobsText + text[this.findWhatJobsText.length]
                        await this.setTypingWhatJobsText(text, to, true)
                    }
                }, 200)
            } else {
                await setTimeout(async () => {
                    this.findWhatJobsText = this.findWhatJobsText.substring(0, this.findWhatJobsText.length-1)
                    await this.setTypingWhatJobsText(text, to, false)
                }, 100)
            }
        },
        cycleTypingWhatJobs() {
            let firstItem = this.findWhatJobsOptions[0]
            let iterIndex = 0
            this.setTypingWhatJobsText(firstItem.text, firstItem.to)

            let interval = setInterval(() => {
                iterIndex++

                if(iterIndex >= this.findWhatJobsOptions.length) {
                    iterIndex = 0
                    clearInterval(interval)
                }
                
                let nextItem = this.findWhatJobsOptions[iterIndex]
                this.setTypingWhatJobsText(nextItem.text, nextItem.to)
            }, 5000)
        }
    },
    async mounted() {
        let [searchPromise, lookingForResources, roleResources, regionResources] = await Promise.all([this.search(), LookingForResource.all(), RoleResource.all(), MetroAreaResource.all()])
        this.lookingForResources = lookingForResources
        this.roleResources = roleResources
        this.loading = false
        
        this.cycleTypingWhatJobs()
    }
}
</script>

<template>
    <div>
        <section :class="classesHeaderSection">
            <b-container>
                <h2 class="text-center">Rapidly <u>hire</u> or <u>join</u> your ideal team</h2>
                <h4 class="text-center mt-4">More than just Node.js Jobs, give it a try!</h4>
                <!-- Connect with high quality candidates in one click -->
                <div class="text-center main-buttons mt-5">
                    <b-button :to="{ name: 'signupCompany' }" size="lg" variant="primary" class="btn-pop mr-md-4 mb-2" v-if="!(userResource && userResource.readonly.companies.length > 0)">Hire Developers</b-button>
                    <b-button :to="{ name: 'signupDeveloper' }" size="lg" variant="primary" class="btn-pop mb-2" v-if="!(userResource && userResource.readonly.profiles.length > 0)">Create a <strong>Developer Profile</strong></b-button>
                    <b-button :to="findWhatJobsLinkTo" size="lg" variant="secondary" class="btn-pop ml-md-4 mb-2 typewriter-button">Find <strong class="typewriter-text anim-typewriter" v-text="findWhatJobsText"></strong> Jobs</b-button>
                </div>
            </b-container>
        </section>

        <section class="filters">
            <b-container>
                <form @submit.prevent="onSubmit">
                    <b-card class="mb-2 filters-card">
                        <b-row>
                            <b-col md="4">
                                <b-form-group label="Job Listing Keywords">
                                    <b-input v-model="searchKeywords" placeholder="Skills, Location, Company Name, etc." />
                                </b-form-group>
                            </b-col>

                            <b-col md="4">
                                <b-form-group label="Looking For">
                                    <select v-if="lookingForResources.length > 0" class="form-control custom-select mb-2 mr-sm-2 mb-sm-0" v-model="selectedFilterResources.type">
                                        <option :value="undefined" selected>Anything</option>
                                        <option v-for="(resource, i) in lookingForResources" :key="i" :value="resource">{{ resource }}</option>
                                    </select>
                                </b-form-group>
                            </b-col>

                            <b-col>
                                <b-form-group>
                                    <template slot="label">
                                        <br />
                                    </template>
                                    <b-button-group class="float-right">
                                        <b-button variant="outline-secondary" @click="filtersExpanded = !filtersExpanded"
                                            ><span v-if="filterLength > 0"
                                                >Filters <b-badge variant="dark">{{ filterLength }}</b-badge></span
                                            ></b-button
                                        >
                                        <b-button variant="primary" type="submit" @click="onSubmit">Search</b-button>
                                    </b-button-group>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <hr v-if="filtersExpanded" />

                        <b-row class="mt-3" v-if="filtersExpanded">
                            <b-col>
                                <b-form-group label="Software Tech/Skills">
                                    <resource-search
                                        :resourceClass="$resources.SkillResource"
                                        :filter="(resource) => !~selectedFilterResources.skills.map((resource) => resource.id).indexOf(resource.id)"
                                        @select="(resource) => selectedFilterResources.skills.push(resource)"
                                        name="skills"
                                        height="250"
                                        placeholder="Start typing to search... (eg. TypeScript)"
                                    ></resource-search>
                                    <b-badge variant="primary" v-for="(skillResource, i) in selectedFilterResources.skills" :key="i" class="mr-1">
                                        {{ skillResource }}
                                        <b-button type="button" class="close skill-badge ml-1" @click="selectedFilterResources.skills.splice(selectedFilterResources.skills.indexOf(skillResource), 1)">×</b-button>
                                    </b-badge>
                                </b-form-group>

                                <b-form-group label="Remote Level">
                                    <b-form-select v-model="selectedFilterResources.remote_level">
                                        <b-form-select-option :value="undefined">No Preference</b-form-select-option>
                                        <b-form-select-option :value="4">Remote Only</b-form-select-option>
                                        <b-form-select-option :value="3">Most Days</b-form-select-option>
                                        <b-form-select-option :value="2">Sometimes</b-form-select-option>
                                        <b-form-select-option :value="1">Never</b-form-select-option>
                                    </b-form-select>
                                </b-form-group>

                                <b-form-group label="Role">
                                    <b-form-checkbox v-model="selectedFilterResources.roles" v-for="(roleResource, i) in roleResources" :key="i" :value="roleResource">
                                        {{ roleResource }}
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>

                            <b-col>
                                <b-form-group label="Regions">
                                    <region-select v-model="selectedFilterResources.regions" />
                                    <b-form-group v-if="selectedFilterResources.regions.length > 0">
                                        <template slot="label">
                                            Candidates located in:
                                            <b-badge href="javascript:{}" variant="light" @click="selectedFilterResources.regions = []" class="float-right">Reset</b-badge>
                                        </template>
                                        <b-badge v-for="(region, i) in selectedFilterResources.regions" :key="i" class="mb-1 mr-1">{{ region }}</b-badge>
                                    </b-form-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card>
                </form>
            </b-container>
        </section>

        <section class="listings">
            <b-container>
                <h1>Software Engineering Job Listings / Search Results:</h1>
            </b-container>

            <b-container v-if="!loading && listingResources.length > 0">
                <div v-for="(listing, i) in listingResources" :key="i" :class="`mb-3 ${listing.get('is_featured') ? 'featured' : ''}`">
                    <job-posting-cell :listing-resource="listing" />
                </div>

                <b-pagination
                    v-if="pageData && pageData.pages > 1"
                    @input="onPageChange"
                    :value="pageNumberCurrent"
                    :total-rows="pageData.count"
                    :per-page="pageData.pageSize"
                    prev-text="Prev"
                    next-text="Next"
                    align="center"
                    hide-ellipsis
                >
                </b-pagination>
            </b-container>

            <b-container v-else-if="!loading && listingResources.length === 0">
                <no-results>
                    <p>Try <a href="javascript:{}" @click="filtersExpanded = true">changing your search criteria</a> to expand your results</p>
                </no-results>
            </b-container>

            <b-container v-else-if="loading" class="loading">
                <b-card class="mb-3">
                    <b-skeleton width="85%"></b-skeleton>
                    <b-skeleton width="55%"></b-skeleton>
                    <b-skeleton width="100%"></b-skeleton>
                </b-card>
                <b-card class="mb-3">
                    <b-skeleton width="85%"></b-skeleton>
                    <b-skeleton width="55%"></b-skeleton>
                    <b-skeleton width="70%"></b-skeleton>
                    <b-skeleton width="55%"></b-skeleton>
                    <b-skeleton width="70%"></b-skeleton>
                    <b-skeleton width="55%"></b-skeleton>
                    <b-skeleton width="70%"></b-skeleton>
                </b-card>
                <b-card>
                    <b-skeleton width="85%"></b-skeleton>
                    <b-skeleton width="55%"></b-skeleton>
                    <b-skeleton width="70%"></b-skeleton>
                </b-card>
            </b-container>
        </section>

    </div>
</template>

<style lang="scss">
@import '@/assets/main.scss';

// .header {
//     code {
//         display: inline-block;
//         color: #ccc;
//         font-weight: 700;
//         background-color: #fff;;
//         padding: 10px;
//         border-radius: 10px;
//     }
// }

.main-buttons {
    transition: all 0.5s ease;
}

.filters {
    margin-top: -127px;

    .filters-card {
        background-color: #ffffffb8;
    }
}

.page-title-blue {
    height: 500px;
    background-image: url(../assets/img/header-1.png);
    background-size: cover;
    background-position: bottom;
    padding-top: 90px;
    color: #fff;

    h2 {
        font-weight: 700;
        font-size: 50px;
    }
}

// .has-profile {
//     height: 310px;
//     padding-top: 76px;

//     h2 {
//         display: none;
//     }

//     .main-buttons {
//         margin-top: 2rem !important;
//     }
// }

.listings {
    h1 {
        margin: 0 0 0.5rem 0;
        font-size: 1.5rem;
        font-weight: 700;
        line-height: 1.2;
        color: #b7b7b7
    }
}

.typewriter-button {
    width: 250px;
}

.typewriter-text {
    position: relative;
    top: 50%;  
    width: 24em;
    margin: 0 auto;
    border-right: 2px solid rgba(255,255,255,.75);
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    transform: translateY(-50%);    
}

.anim-typewriter {
    animation: typewriter 4s steps(44) 1s 1 normal both,
    blinkTextCursor 500ms steps(44) infinite normal;
}

@keyframes typewriter {
    from { width: 0; }
    to { width: 24em; }
}
@keyframes blinkTextCursor {
    from { border-right-color: rgba(255,255,255,.75); }
    to { border-right-color: transparent; }
}

@media (max-width: 768px) {
    .filters {
        margin-top: 0;
    }

    .header {
        //zoom: 0.6;

        h2 {
            font-size: 2rem;
        }
    }

    .has-profile {
        padding-top: 110px;
        background-position-y: 0;
    }

    // .listing {
    //     zoom: 0.7;
    // }

    .main-buttons {
        .btn, .typewriter-button {
            display: block;
            width: 80% !important;
            margin: 0 auto;
        }
    }
}
</style>
